import { gql } from '@apollo/client';

export default gql`
  mutation updateDCategory(
    $_id: String
    $branch: String
    $name: String
    $nameAr: String
    $disabled: Boolean
    $additionId: String
    $note: String
    $ref: String
    $perfix: String
  ) {
    updateDCategory(
      _id: $_id
      branch: $branch
      name: $name
      nameAr: $nameAr
      disabled: $disabled
      additionId: $additionId
      note: $note
      ref: $ref
      perfix: $perfix
    ) {
      ok
      message
      data
      error
    }
  }
`;
